import React from 'react';

import { Value } from './Content.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function _Title(props) {
    if (!Utilities.Config.checkVisibility(props, 'ListTitle')) {
        return null;
    }
    return <Value {...props} value={props.content} />;
}
const Title = Token.withContentTokenParsing(
    _Title,
    { extraParseConditionHandler: (props) => [props.visibilityHash] },
    (props, keyword) => {
        const data = props.data || {};
        const visibility = props.visibility || {};
        if (!props.forceVisibility && !props.builder && visibility[keyword] == false) {
            return '';
        }
        let replaceString = '';
        switch (keyword) {
            case Token.ListTitle:
                if (!Utilities.isNullOrWhitespace(data.Title)) {
                    replaceString = Token.getReplacementString(data.Title);
                } else if (props.builder) {
                    replaceString = '[List Title (Quicklists Only)]'
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString
    }
);
const Tokens = () => [Token.getWrappedTokenConfig('List Title', Token.ListTitle)];
const TypeConfig = {
    panel: {
        block: (firstPageOnly) => {
            const group = 'block';
            let options = [];
            if (firstPageOnly) {
                options = [{
                    display: 'Only Show On First Page',
                    group,
                    fullWidth: true,
                    name: 'renderOnlyFirst',
                    type: 'checkbox',
                    value: false
                }];
            }
            return {
                group,
                label: 'Design',
                options: [
                    {
                        fullWidth: true,
                        group,
                        type: 'info',
                        value: '* List Title is visible for Quicklists only'
                    },
                    ...options,
                    {
                        display: 'Design list title here',
                        label: 'List Title Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header1, tagExtras: `style="text-align:center;"`, text: `{${Token.ListTitle}}`, token: Token.ListTitle })
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout', {}, undefined, {}),
        visibility: (props) => {
            const _props = props || {};
            return {
                options: [
                    {
                        display: 'List Title',
                        name: 'ListTitle',
                        type: 'checkbox',
                        value: true,
                        visible: () => false,
                        ..._props
                    }
                ]
            };
        }
    }
};

export {
    Title as Component,
    Tokens,
    TypeConfig
}